module.exports = __webpack_public_path__ + "img/corner-logo.e66dd8d9.png";